module.exports = __webpack_public_path__ + "img/logo-agentik.4f1928c6.svg";